export const updateQuantity = async (
  line,
  quantity,
  sections = 'mini-cart,header',
  sections_url = '',
  location = window.routes.cart_change_url
) => {
  const response = await fetch(location, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      line,
      quantity,
      sections,
      sections_url
    }),
  }).then(res => res.json())
  .catch(err => err.json())

  return response
}

export const updateQuantityMultiple = async (
  updates,
  sections = 'mini-cart,header',
  location = window.routes.cart_update_url
) => {
  const response = await fetch(location, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      updates,
      sections,
    }),
  })
  return await response.json()
}

export const addToCart = async (
  payload,
  sections = 'mini-cart,header,cart-notification,main-cart',
  location = window.routes.cart_add_url
) => {
  const response = await fetch(location, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      sections,
      ...payload,
    }),
  }).then(res => res.json())
  .catch(err => err.json())

  return response
}
